// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.value_your_trade_card[data-v-7fcb4160] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.custom_legend[data-v-7fcb4160] {
  position: absolute;
  display: inline-block;
  background: #fff;
  z-index: 9;
  font-size: 12px;
  top: -12px;
  left: 30px;
  padding: 0 6px;
  color: #000;
  opacity: 0.8;
}
.card_font_sizes h5[data-v-7fcb4160] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.card_font_sizes p[data-v-7fcb4160] {
  margin-bottom: 3px;
  white-space: initial;
  font-size: 13px;
  text-overflow: ellipsis;
  min-width: 100px;
  overflow: hidden;
}
.min-120[data-v-7fcb4160] {
  min-height: 100px;
}
.ft-c-13[data-v-7fcb4160] {
  font-size: 12px;
}
.max-60[data-v-7fcb4160] {
  min-width: 60px;
  display: inline-block;
}
.my_appraisal_appointment[data-v-7fcb4160] {
  border: 1px solid #eee;
  border-radius: 15px;
  padding: 5px;
}
.my_appraisal_appointment h5[data-v-7fcb4160] {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  white-space: initial;
  margin: 0;
}
.my_appraisal_appointment p[data-v-7fcb4160] {
  margin-bottom: 3px;
  white-space: initial;
  font-size: 13px;
  text-overflow: ellipsis;
  min-width: 100px;
  overflow: hidden;
}
.my_appraisal_appointment .success[data-v-7fcb4160] {
  color: green;
}
.my_appraisal_appointment .red[data-v-7fcb4160] {
  color: #FF9800;
}
.my_appraisal_appointment img[data-v-7fcb4160] {
  height: 65px;
  display: block;
  margin: auto;
}
.animate_bottom[data-v-7fcb4160] {
  animation: animateBottom-7fcb4160 2s;
  transition: 0.5s;
}
@keyframes animateBottom-7fcb4160 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
@media (min-width: 1900px) {
.my_appraisal_appointment h5[data-v-7fcb4160] {
    font-size: 13px;
}
.my_appraisal_appointment p[data-v-7fcb4160] {
    font-size: 12px;
}
.custom_legend[data-v-7fcb4160] {
    font-size: 13px;
}
.ft-c-13[data-v-7fcb4160] {
    font-size: 13px;
}
}
@media (min-width: 2500px) {
.my_appraisal_appointment h5[data-v-7fcb4160] {
    font-size: 16px;
}
.my_appraisal_appointment p[data-v-7fcb4160] {
    font-size: 14px;
}
.custom_legend[data-v-7fcb4160] {
    font-size: 16px;
}
.ft-c-13[data-v-7fcb4160] {
    font-size: 16px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/SlideOutPanel/TvmAppraisalAppointment/TvmAppraisalAppointment.vue","webpack://./TvmAppraisalAppointment.vue"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,mBAAA;EACA,YAAA;ACDF;ADIA;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ACFF;ADKA;EAEI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;ACJJ;ADFA;EAUI,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ACLJ;ADSA;EACE,iBAAA;ACPF;ADUA;EACE,eAAA;ACRF;ADWA;EACE,eAAA;EACA,qBAAA;ACTF;ADaA;EAnDE,sBAAA;EACA,mBAAA;EACA,YAAA;ACyCF;ADQA;EA/BI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;AC0BJ;ADCA;EAvBI,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;ACyBJ;ADPA;EAKI,YAAA;ACKJ;ADVA;EASI,cAAA;ACIJ;ADbA;EAaI,YAAA;EACA,cAAA;EACA,YAAA;ACGJ;ADCA;EACE,oCAAA;EACA,gBAAA;ACCF;ADEA;AACE;IACE,2BAAA;ACAF;ADGA;IACE,wBAAA;ACDF;AACF;ADIA;AACE;IAEI,eAAA;ACHJ;ADCA;IAMI,eAAA;ACJJ;ADQA;IACE,eAAA;ACNF;ADSA;IACE,eAAA;ACPF;AACF;ADUA;AACE;IAEI,eAAA;ACTJ;ADOA;IAMI,eAAA;ACVJ;ADcA;IACE,eAAA;ACZF;ADeA;IACE,eAAA;ACbF;AACF","sourcesContent":["\n// reuseable css\n.value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n\n.card_font_sizes {\n  h5 {\n    font-size: 12px;\n    font-weight: 600;\n    color: #000;\n    white-space: initial;\n    margin: 0;\n  }\n\n  p {\n    margin-bottom: 3px;\n    white-space: initial;\n    font-size: 13px;\n    text-overflow: ellipsis;\n    min-width: 100px;\n    overflow: hidden;\n  }\n}\n\n.min-120 {\n  min-height: 100px;\n}\n\n.ft-c-13 {\n  font-size: 12px;\n}\n\n.max-60 {\n  min-width: 60px;\n  display: inline-block\n}\n\n// end reuseable css\n.my_appraisal_appointment {\n  .value_your_trade_card();\n  .card_font_sizes();\n\n  .success {\n    color: green;\n  }\n\n  .red {\n    color: #FF9800;\n  }\n\n  img {\n    height: 65px;\n    display: block;\n    margin: auto;\n  }\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 1900px) {\n  .my_appraisal_appointment {\n    h5 {\n      font-size: 13px;\n    }\n\n    p {\n      font-size: 12px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 13px;\n  }\n\n  .ft-c-13 {\n    font-size: 13px;\n  }\n}\n\n@media (min-width: 2500px) {\n  .my_appraisal_appointment {\n    h5 {\n      font-size: 16px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n  }\n\n  .custom_legend {\n    font-size: 16px;\n  }\n\n  .ft-c-13 {\n    font-size: 16px;\n  }\n}\n",".value_your_trade_card {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.custom_legend {\n  position: absolute;\n  display: inline-block;\n  background: #fff;\n  z-index: 9;\n  font-size: 12px;\n  top: -12px;\n  left: 30px;\n  padding: 0 6px;\n  color: #000;\n  opacity: 0.8;\n}\n.card_font_sizes h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.card_font_sizes p {\n  margin-bottom: 3px;\n  white-space: initial;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  min-width: 100px;\n  overflow: hidden;\n}\n.min-120 {\n  min-height: 100px;\n}\n.ft-c-13 {\n  font-size: 12px;\n}\n.max-60 {\n  min-width: 60px;\n  display: inline-block;\n}\n.my_appraisal_appointment {\n  border: 1px solid #eee;\n  border-radius: 15px;\n  padding: 5px;\n}\n.my_appraisal_appointment h5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #000;\n  white-space: initial;\n  margin: 0;\n}\n.my_appraisal_appointment p {\n  margin-bottom: 3px;\n  white-space: initial;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  min-width: 100px;\n  overflow: hidden;\n}\n.my_appraisal_appointment .success {\n  color: green;\n}\n.my_appraisal_appointment .red {\n  color: #FF9800;\n}\n.my_appraisal_appointment img {\n  height: 65px;\n  display: block;\n  margin: auto;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n@media (min-width: 1900px) {\n  .my_appraisal_appointment h5 {\n    font-size: 13px;\n  }\n  .my_appraisal_appointment p {\n    font-size: 12px;\n  }\n  .custom_legend {\n    font-size: 13px;\n  }\n  .ft-c-13 {\n    font-size: 13px;\n  }\n}\n@media (min-width: 2500px) {\n  .my_appraisal_appointment h5 {\n    font-size: 16px;\n  }\n  .my_appraisal_appointment p {\n    font-size: 14px;\n  }\n  .custom_legend {\n    font-size: 16px;\n  }\n  .ft-c-13 {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
